import { svg } from '../utils/svg.js';
import { byId } from '../utils/dom.js';
import { Control } from 'ol/control';
import { i18n } from '../i18n.js';

/**
 * @module gui/copyright
 */
export const copyright = {

  /**
   * ID of the div that contains the copyright
   * @type String
   * @private
   */
  _domId: 'map-copyright',

  /**
   * @type {JsonStatReader} NAFIDAS JSON-stat reader
   */
  _reader: null,

  /**
   * @type {ol/Control}
   */
  control: null,

  /**
   * Initialize the module
   * @param {JsonStatReader} jsonStatReader
   */
  init (jsonStatReader) {
    this._reader = jsonStatReader;
    this.control = this._get();
    return this;
  },

  _get () {
    return new Control({
      element: document.getElementById(this._domId)
    });
  },

  /**
   * Render the copyright text.
   * The passed reference string is appended to the copyright.
   * @returns {void}
   * @param {String} reference
   */
  render (reference = null) {
    const p = document.createElement('p');

    p.innerHTML = this.getHtml(reference);
    byId(this._domId).append(p);
  },

  getHtml (reference = null) {
    const txt = `© swisstopo, © WSL/${this._reader.getTransl('Schweizerisches Landesforstinventar')}`;

    return `${txt}, ${this._getDate()} ` + (reference ? `<span class="${this._domId}__reference">${reference}</span>` : '');
  },

  /**
   * Adds a reference to the copyright element below the map.
   *
   * @param {string} reference The reference text (product item number) to be added.
   * @return {void} This method does not return a value.
   */
  addReference (reference) {
    const span = document.createElement('span');
    span.classList.add(this._domId + '__reference');
    span.append(reference);
    document.querySelector('.' + this._domId + ' > p').append(span);
  },

  /**
   * Return the formatted date when the data set was last updated.
   * @returns {String} date
   * @private
   */
  _getDate () {
    const date = this._reader.getUpdate();

    /**
     * note: we always want the swiss date style to be consistent with other possible dates on the page.
     */
    return date.toLocaleDateString('de-CH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  },

  /**
   * Export the copyright as SVG.
   * @return {SVGGElement}
   */
  exportSvg () {
    const g = svg.create('g', {
      id: 'footer'
    });
    const label = document.getElementById(this._domId).textContent;
    let txt = svg.create('text');
    txt.innerHTML = label;
    g.append(txt);

    return g;
  }
};